<template>
  <div>
    <v-dialog
      scrollable
      persistent
      width="646px"
      v-model="openDescription.flag"
    >
      <v-card>
        <v-card-title class="title justify-space-between">
          <div>Webinar Details</div>
          <div>
            <v-btn @click="openDescription.flag = false" icon>
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="d-flex justify-space-between flex-column">
            <div>
              <div class="webinar-title my-3">
                {{ webinar.title }}
              </div>
              <div class="d-flex justify-space-between pt-2 my-3">
                <div class="user-name">By {{ webinar.owner.name }}</div>
                <div>
                  <span class="level">{{ webinar.level }}</span>
                </div>
              </div>
            </div>
            <div class="description mt-2">
              <!-- <span> {{ webinar.description }} </span>  -->
              <div v-html="webinar.description"></div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions
          :class="
            !$vuetify.breakpoint.xsOnly
              ? 'd-flex justify-space-between align-center'
              : 'd-block'
          "
          class="px-6"
        >
          <!-- <footer class=""> -->
          <div
            :class="$vuetify.breakpoint.xsOnly ? 'mb-3' : ''"
            class="d-flex align-center"
          >
            <div>
              <v-img class="calendar" :src="webinar_calendar"></v-img>
            </div>
            <span style="height: 50px" class="mx-4">
              <v-divider vertical></v-divider>
            </span>
            <div>
              <div class="event event-date">
                {{ formattedDate(webinar.date) }}
              </div>
              <div class="event event-time">
                Starts at {{ formattedTime(webinar.time) }},
                {{ webinar.duration }} Hr Event
              </div>
            </div>
          </div>
          <div :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : ''">
            <!-- <v-btn height="45px" width="200px" color="primary" class="register">
              Register for ₹2200
            </v-btn> -->
            <RegisterBtnVue
              v-if="
                webinar.status != 'Closed' && webinar.is_my_webinar == false
              "
              :closedWebinarDialog="openDescription"
              :webinarDetails="webinar"
            />
          </div>
          <!-- </footer> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RegisterBtnVue from "./RegisterBtn.vue";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat"; // Import custom parse format plugin

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

export default {
  name: "WebinarsDetailModal",
  props: {
    openDescription: {
      type: Object,
      required: true,
    },
  },
  components: {
    RegisterBtnVue,
  },
  data() {
    return {
      // webinar: this.openDescription.item,
      webinar_calendar: require("@/assets/images/webinar-calendar.svg"),
    };
  },
  computed: {
    webinar() {
      return this.openDescription.item;
    },
  },
  methods: {
    formattedDate(date) {
      return dayjs(date).format("dddd, D MMMM YYYY");
    },
    formattedTime(time) {
      return dayjs(time, "HH:mm:ss").format("h:mmA");
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .title {
    font-size: 16px !important;
    font-weight: 800;
    line-height: 24px !important;
  }
  .user-name {
    font-size: 14px !important;
    font-weight: 500;
    line-height: 19.12px !important;
  }
  .description {
    font-size: 12px !important;
    font-weight: 500;
    line-height: 15px !important;
  }
  .calendar {
    width: 28px !important;
    height: 28px !important;
  }
  .event {
    font-size: 12px !important;
    font-weight: 500;
    line-height: 16.39px !important;
    text-align: left;
  }
  .level {
    font-size: 12px !important;
    font-weight: 500;
    line-height: 16.39px !important;
    text-align: left;
  }
  .user-img {
    width: 100% !important;
    height: 220px !important;
    border-radius: 0px !important;
  }
}
.title {
  color: #fff;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.625rem; /* 130% */
  background: var(--Primary-Blue, #2d8cff);
}
.user-name {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  text-align: left;
  color: #333333cc;
}
.description {
  font-family: Avenir;
  font-size: 13px;
  font-weight: 500;
  line-height: 15px;
  text-align: left;
  color: #333333a3;
}
.calendar {
  width: 32px;
  height: 32px;
}
.read-more {
  color: #2f80ed;
  cursor: pointer;
}
.webinar-title {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: #333333;
}
.register {
  width: 200px;
  height: 45px;
  gap: 10px;
  border-radius: 6px;
  border: 1px 0px 0px 0px;
  //   Register text
  text-transform: capitalize;
  font-family: Avenir;
  font-size: 16px;
  font-weight: 800;
  line-height: 21.86px;
  text-align: center;
  color: #ffffff;
}
.event {
  font-family: Avenir;
  font-size: 13px;
  font-weight: 500;
  line-height: 17.76px;
  text-align: left;
  color: #333333;
}
.event-date {
}
.event-time {
  color: #333333cc;
}
.level {
  font-family: Avenir;
  font-size: 13px;
  font-weight: 500;
  line-height: 17.76px;
  text-align: left;
  color: #333333;
  background: #ffcf87;
  padding: 4px 8px 4px 8px;
  border-radius: 40px;
  opacity: 0px;
}
</style>
